module.exports = __webpack_public_path__ + "img/Hiraya-Diagram_Without Text.64d69790.png";